import { api } from "@/lib/api";
import { toast } from "sonner";

// Browsers block opening "data:" links in a new tab, so convert them to a blob link first.
export function openFile(e, url) {
  if (!url || !url.startsWith("data:")) return;
  e.preventDefault();
  const tab = window.open("", "_blank");
  fetch(url).then((r) => r.blob()).then((blob) => {
    const link = URL.createObjectURL(blob);
    if (tab) tab.location.href = link; else window.location.href = link;
    setTimeout(() => URL.revokeObjectURL(link), 120000);
  }).catch(() => { if (tab) tab.close(); });
}

// Board files live privately in Google Drive and are served through the app (Governance access only).
export function openBoardFile(e, meetingId, doc) {
  if (!doc?.drive_file_id) return openFile(e, doc?.url);
  e.preventDefault();
  const tab = window.open("", "_blank");
  api.get(`/board-meetings/${meetingId}/files/${doc.id}`, { responseType: "blob" }).then((r) => {
    const link = URL.createObjectURL(r.data);
    if (tab) tab.location.href = link; else window.location.href = link;
    setTimeout(() => URL.revokeObjectURL(link), 120000);
  }).catch(async (err) => {
    if (tab) tab.close();
    let msg = "Couldn't open the file.";
    try { msg = JSON.parse(await err.response.data.text()).detail || msg; } catch { /* keep default */ }
    toast.error(msg);
  });
}
